import React, { useState } from 'react';
import { PercentIcon, CheckIcon, XIcon, TentIcon } from 'lucide-react';
type PromoCodeInputProps = {
  onApply: (code: string) => void;
  onClear: () => void;
  appliedCode?: string | null;
  isValid?: boolean;
  discount?: number | null;
};
export const PromoCodeInput: React.FC<PromoCodeInputProps> = ({
  onApply,
  onClear,
  appliedCode = null,
  isValid = false,
  discount = null
}) => {
  const [code, setCode] = useState('');
  const [isApplying, setIsApplying] = useState(false);
  const handleApply = () => {
    if (!code.trim()) return;
    setIsApplying(true);
    // Simulate API call to validate code
    setTimeout(() => {
      onApply(code);
      setIsApplying(false);
    }, 800);
  };
  if (appliedCode) {
    return <div className="bg-gradient-to-r from-amber-600/20 to-amber-700/20 border border-amber-500/30 rounded-lg p-4" data-id="element-4536">
        <div className="flex items-center justify-between" data-id="element-4537">
          <div className="flex items-center" data-id="element-4538">
            <div className="w-10 h-10 bg-amber-600/30 rounded-lg flex items-center justify-center mr-3" data-id="element-4539">
              {isValid ? <PercentIcon size={20} className="text-amber-500" data-id="element-4540" /> : <XIcon size={20} className="text-red-500" data-id="element-4541" />}
            </div>
            <div data-id="element-4542">
              <div className="flex items-center" data-id="element-4543">
                <TentIcon size={16} className="text-amber-500 mr-1.5" data-id="element-4544" />
                <span className="text-white font-medium" data-id="element-4545">
                  Código de feria aplicado
                </span>
              </div>
              <div className="text-amber-300 text-sm mt-0.5" data-id="element-4546">
                {isValid ? `"${appliedCode}" - ${discount}% de descuento aplicado` : `"${appliedCode}" - Código inválido o expirado`}
              </div>
            </div>
          </div>
          <button onClick={onClear} className="text-amber-300 hover:text-amber-200 bg-amber-800/30 hover:bg-amber-800/50 rounded-lg px-3 py-1.5 text-sm transition-colors" data-id="element-4547">
            Eliminar
          </button>
        </div>
      </div>;
  }
  return <div className="bg-blue-900/30 border border-blue-800/30 rounded-lg p-4" data-id="element-4548">
      <div className="flex items-center mb-3" data-id="element-4549">
        <PercentIcon size={18} className="text-blue-400 mr-2" data-id="element-4550" />
        <h3 className="text-white font-medium" data-id="element-4551">
          ¿Tienes un código promocional?
        </h3>
      </div>
      <div className="flex items-center gap-2" data-id="element-4552">
        <div className="relative flex-1" data-id="element-4553">
          <input type="text" placeholder="Ingresa el código de feria" value={code} onChange={e => setCode(e.target.value)} className="w-full bg-blue-950/50 border border-blue-800/50 rounded-lg px-4 py-2.5 text-white placeholder-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-4554" />
        </div>
        <button onClick={handleApply} disabled={!code.trim() || isApplying} className={`${!code.trim() || isApplying ? 'bg-blue-700/50 text-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 text-white'} px-4 py-2.5 rounded-lg transition-colors flex items-center`} data-id="element-4555">
          {isApplying ? <>
              <div className="animate-spin mr-2 h-4 w-4 border-2 border-blue-300 border-t-transparent rounded-full" data-id="element-4556"></div>
              Aplicando...
            </> : <>Aplicar</>}
        </button>
      </div>
    </div>;
};